import {faEnvelope} from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import {faLocationDot} from "@fortawesome/pro-solid-svg-icons/faLocationDot";
import {faUser} from "@fortawesome/pro-solid-svg-icons/faUser";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {MailItemSendsType, SendsHistoryEntryType} from "@twigsby/client-data";
import {
    ColourSolid,
    FlexAlign,
    FlexGap,
    FlexJustify,
    ItemRow,
    ItemRowSize,
    Pill,
    PillSize,
    StackHorizontal,
    StackVertical,
    useLayout,
    useTranslation
} from "@twigsby/frontend-framework";
import {FormatLocaleDateTime} from "@twigsby/helpers";
import {enGB} from "date-fns/locale";
import React from "react";
import {
    MailItemNoThumbnail,
    MailItemThumbnail,
    MailItemTopUpRequired,
    MailPartTypeEnum
} from "../Mail/MailItemThumbnails";

const SendsHistoryItem = (props: SendsHistoryEntryType) => {
    const { isMedium } = useLayout();

    return (
        <ItemRow
            static={!props.linkToSend}
            size={ItemRowSize.Large}
            actionLink={props.linkToSend ? { target: '_parent', url: `/mail/inbox/${props.mailItem.mailUuid}` } : undefined}
            extraClass={'pl-lg'}
        >
            {isMedium ? (
                <SendsHistoryItemContent {...props} />
            ) : (
                <SendsHistoryItemContentSmall {...props} />
            )}
        </ItemRow>
    )
}

const SendsHistoryItemContent = (props: SendsHistoryEntryType) => {
    const { t } = useTranslation();

    return (
        <>
            <div>
                <SendsHistoryItemThumbnail {...props.mailItem} />
            </div>

            {!props.hidePageDetails && (
                <StackVertical gap={FlexGap.ExtraSmall}>
                    <div>
                        {props.title}
                        {props.title !== props.mailItem.trackingId && (
                            <div className={'fade'}>
                                {props.mailItem.trackingId}
                            </div>
                        )}
                    </div>

                    {props.isDeleted && (
                        <Pill content={t('status.deleted')} colour={ColourSolid.Alert} size={PillSize.Small} />
                    )}
                </StackVertical>
            )}

            {!props.hideUserDetails && (
                <div>{props.user.name}</div>
            )}

            <div>{props.address?.formatted}</div>

            <div>{props.postageOption?.name}</div>

            <div>{FormatLocaleDateTime(props.dateCreated, enGB)}</div>
        </>
    )
}

const SendsHistoryItemContentSmall = (props: SendsHistoryEntryType) => {
    return (
        <>
            <div className={'pl-lg'}>
                <SendsHistoryItemThumbnail {...props.mailItem} />
            </div>
            <StackVertical gap={FlexGap.Small}>
                {!props.hidePageDetails && (
                    <StackHorizontal justify={FlexJustify.Between} align={FlexAlign.Center}>
                        <div>
                            <h5 className={'m-0'}>{props.title}</h5>
                            <span className={'fade'}>
                                {props.mailItem.trackingId}
                            </span>
                        </div>
                        <small className={'fade'}>{FormatLocaleDateTime(props.dateCreated, enGB)}</small>
                    </StackHorizontal>
                )}

                <StackVertical gap={FlexGap.ExtraSmall}>
                    {!props.hideUserDetails && (
                        <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 'var(--xs-unit)'}}>
                            <FontAwesomeIcon icon={faUser} fixedWidth={true} />
                            <div>{props.user.name}</div>
                        </div>
                    )}

                    <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 'var(--xs-unit)'}}>
                        <FontAwesomeIcon icon={faLocationDot} fixedWidth={true} />
                        <div>{props.address?.formatted}</div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 'var(--xs-unit)'}}>
                        <FontAwesomeIcon icon={faEnvelope} fixedWidth={true} />
                        <div>{props.postageOption?.name}</div>
                    </div>
                </StackVertical>

            </StackVertical>
        </>
    )
}

const SendsHistoryItemThumbnail = (props: MailItemSendsType) => {
    return (
        <div>
            {props.files.map((file, index) =>
                <div key={`sendsHistoryEnvelopesThumb${index}`}>
                    {file.thumbnails && file.thumbnails[0]?.linkToFile ? (
                        <MailItemThumbnail {...file.thumbnails[0]} />
                    ) : index === 0 && props.files[0]?.topupRequired ? (
                        <MailItemTopUpRequired />
                    ) : <MailItemNoThumbnail mailType={MailPartTypeEnum['Mail-Envelopes']} />}
                </div>
            )}

            {props.files.length === 0 && (
                <MailItemNoThumbnail mailType={MailPartTypeEnum['Mail-Envelopes']} />
            )}
        </div>
    )
}

export default SendsHistoryItem
